import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class SessionService extends StorageService {
  constructor() {
    const document = inject<Document>(DOCUMENT);
    let storage: Storage | undefined;
    try {
      // ponytail: can't report here — ErrorHandler -> ErrorService -> SessionService is a DI cycle
      storage = document.defaultView?.sessionStorage;
    } catch {
      storage = undefined;
    }
    super(storage);
  }
}
